import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';
import { Height } from '@material-ui/icons';
import { responsiveFontSizes } from '@material-ui/core';

export  class AddTechnologyModal extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            DomainList:[],
            techlist:[],
            msg:""
        }
      

    }
    componentDidMount() {
        this.getdomain();
        
    }  
    
    ServiceGroupchange(e) {
        if(e.target.value == 'IMS')
        {
            document.getElementById('divDomain').style.display = 'block';
        }
        else
        {
            document.getElementById('divDomain').style.display = 'none';
        }
         this.gettech(e.target.value);
    }

    abc(e) {
        if(e.target.checked == true)
        {
           document.getElementById('divdefault').style.display = 'block';
        }
        else
        {
            document.getElementById('divdefault').style.display = 'none';
            var dropDown = document.getElementById("ddlTechnology");
            dropDown.selectedIndex = 0;

        }
       

    }

    Domainchange(e) {
        if(e.target.value == 'Other')
        {
            document.getElementById('txtDomain').style.display = 'block';
        }
        else
        {
            document.getElementById('txtDomain').style.display = 'none';
        }

    }
    
    getdomain() {
        fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/Domains/"+2).then(response => response.json())
        .then(res=> {            
          this.setState ( { DomainList: res } )
            })
            .catch(err => {
              console.log(err);
          }) 
      }

      gettech(SG) {
        fetch("https://as-mobilization-stage.accenture.com/KTPlanConfig/api/Index/TechnologyList/"+(SG=='AMS'?'AO':'IO')).then(response => response.json())
        .then(res=> {            
          this.setState ( { techlist: res } )
            })
            .catch(err => {
              console.log(err);
          }) 
      
      }
      
    handleSubmit(event){
        event.preventDefault(); 
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = {technologyid:0, technology:event.target.Technology.value, DomainId:event.target.Domain.value,Servicegroup:(event.target.ServiceGroup.value=="AMS"?"AO":(event.target.ServiceGroup.value=="IMS"?"IO":event.target.ServiceGroup.value))
        ,username:this.props.username,DomainName:event.target.DomainText.value,Technologydefault:event.target.Technologydefault.value };
    axios.post('https://as-mobilization-stage.accenture.com/KTPlanConfig/api/AdminTechnology/Post', article,options)
    .then(res=> { 
        this.setState ( { msg: res.data} )
           console.log(res);
           this.props.filterchangetest(); 
           alert(res.data);
          })
          .catch(err => {
            console.log(err);
        }) 
       
        
       

    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'   aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Add Technology
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>
                          <Form.Group controlId='technology'>
                          <div>
                              <Form.Label>Service Group</Form.Label>
                              <Form.Select className='form-control' style={{width:140}} name='ServiceGroup' onChange={(e) => this.ServiceGroupchange(e)} required>
                                  <option>Select</option>
                                  <option>AMS</option>
                                  <option>IMS</option>
                              </Form.Select>
                              </div>
                              <div>
                              <Form.Label>Technology/Tower*</Form.Label>
                              <Form.Control type='text' maxLength={100} style={{width:140}} name='Technology' required placeholder='Technology'></Form.Control>
                              </div>
                             
                              <div   id='divDomain' style={{display:'none'}}>
                              <Form.Label>Domain</Form.Label>
                              <Form.Select className='form-control' onChange={(e) => this.Domainchange(e)} id='ddlDomain' style={{width:140}} name='Domain'>
                              <option value='Select'>Select</option>
                  
                                    {
                                    
                                    this.state.DomainList.map(list =>
                                            <option value={list.value} >{list.text}</option>)
                                    }
                                    <option value='Other'>Other</option>
                                   
                               </Form.Select>
                              <Form.Control id='txtDomain' type='text' maxLength={100} style={{width:140,marginTop:10,display:'none'}} name='DomainText'  placeholder='Enter Domain'></Form.Control>
                              </div> 
                              <div>
                              <Form.Control variant='primary'  type="checkbox"   style={{marginTop:10,marginRight:10,display:'inline',marginBottom:10,width:15,height:15}} onChange={(e) => this.abc(e)}>
                                  
                                  </Form.Control> 
                                  Default to Technology
                                  </div>
                                  <div id='divdefault' style={{display:'none'}}>
                                  <Form.Select className='form-control'   id='ddlTechnology' style={{width:140,display:'block'}} name='Technologydefault'>
                                  <option value='Select'>Select</option>
                      
                                        {
                                        
                                        this.state.techlist.map(list =>
                                                <option value={list.value} >{list.text}</option>)
                                        }
                                        <option value='Other'>Other</option>
                                  </Form.Select>
                             
                                  </div>
                          </Form.Group>  
                        
                          <Form.Group>
                              <Button variant='primary' style={{margin:10,width:100}} className='btn-new btn-confirm' type='submit'>
                                  Save 
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm'>Close
                              </Button>
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
               
            </Modal>
            </div>
        )
    }
}